import {
  AppBar,
  Toolbar,
  CssBaseline,
  makeStyles,
  Typography,
  useTheme,
  useMediaQuery,
  Theme,
  createStyles,
} from '@material-ui/core'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import DrawerComponent from './drawer'
import './navbar.scss'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navlinks: {
      marginLeft: theme.spacing(0),
      display: 'flex',
    },
    logo: {
      flexGrow: 0,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    link: {
      border: '1px solid',
      borderRadius: '10px',
      padding: '3px 6px',
      textDecoration: 'none',
      color: '#8d909a',
      fontSize: '20px',
      marginLeft: theme.spacing(2),
      '&:hover': {
        color: 'white',
      },
    },
  }),
)

function Navbar() {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [scrolledDown, setScrolledDown] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setScrolledDown(scrollY > 10) // trigger fade when scroll position > 10px
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <AppBar
      position='fixed'
      className='app-nav'
      style={{
        opacity: scrolledDown ? 0.5 : 1,
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      <CssBaseline />
      <Toolbar className='tools'>
        <Typography variant='h4' className={classes.logo}>
          <img
            src='./img/Gold.png'
            alt='Logo'
            className='tools-img'
            style={{ width: '35px', height: 'auto' }}
          />
        </Typography>
        <p className='title'>TEMPLAR G✠LD</p>
        <DrawerComponent />
      </Toolbar>
    </AppBar>
  )
}

export default Navbar